import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { getEmployerOnboardingPath } from '../../utils/employerOnboarding';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, verificationStatus, isSessionExpired, logout, user } = useAuthStore();
  const sessionExpired = isAuthenticated && isSessionExpired();

  useEffect(() => {
    if (sessionExpired) {
      logout({ reason: 'idle_timeout' });
    }
  }, [logout, sessionExpired]);

  if (isAuthenticated) {
    if (sessionExpired) {
      return children;
    }

    return <Navigate to={getEmployerOnboardingPath(user, verificationStatus)} replace />;
  }

  return children;
};

export default PublicRoute;
